import { translate } from '../../common/helpers/translate.helper';
import { SortOption, SortSelect } from '../../common/SortSelect/SortSelect';

interface OrderOverviewSortSelectProps {
    onChange: (value: SortOption['value']) => void;
    value: SortOption['value'];
}

export const OrderOverviewSortSelect = ({ onChange, value }: OrderOverviewSortSelectProps) => {
    const orderSortOptions: SortOption[] = [
        {
            label: translate('sortOptions.deliveryDate'),
            value: {
                sortField: 'dateDelivery',
                sortDirection: 'DESC',
            },
        },
        {
            label: translate('sortOptions.latest'),
            value: {
                sortField: 'dateUpdated',
                sortDirection: 'DESC',
            },
        },
        {
            label: translate('sortOptions.dateCreated'),
            value: {
                sortField: 'dateCreated',
                sortDirection: 'DESC',
            },
        },
    ];

    const defaultValue = orderSortOptions.at(0)!;

    const selectedOption = orderSortOptions.find(
        (option) => option.value.sortField === value.sortField && option.value.sortDirection === value.sortDirection
    );

    return (
        <SortSelect
            value={selectedOption || defaultValue}
            options={orderSortOptions}
            onChange={(option) => {
                onChange(option!.value);
            }}
        />
    );
};
